import Vue from 'vue'

/** --------------设备参数管理--------------- */
export const addDeviceParamsList = params => {
  return Vue.fetch.post('/apiv1/hr/deviceParam/add', params)
}
export const updateDeviceParamsList = params => {
  return Vue.fetch.post('/apiv1/hr/deviceParam/update', params)
}
export const deleteDeviceParamsList = params => {
  return Vue.fetch.post('/apiv1/hr/deviceParam/delete', params)
}
export const getDeviceParamsList = params => {
  return Vue.fetch.post('/apiv1/hr/deviceParam/findList', params)
}
/** -------------门禁管理--------------- */
export const addAccEventCodeList = params => {
  return Vue.fetch.post('/apiv1/acc/accEventType/add', params)
}
export const updateAccEventCodeList = params => {
  return Vue.fetch.post('/apiv1/acc/accEventType/update', params)
}
export const deleteAccEventCodeList = params => {
  return Vue.fetch.post('/apiv1/acc/accEventType/delete', params)
}
export const getAccEventCodeList = params => {
  return Vue.fetch.post('/apiv1/acc/accEventType/findList', params)
}
/**
 * 更新模板
 * @param {*} params /apiv1/commonConfig/delete
 */
export const templateDelete = params => {
  return Vue.fetch.post('/apiv1/commonConfig/delete', params)
}
/**
 * 更新模板
 * @param {*} params
 */
export const templateUpdate = params => {
  return Vue.fetch.post('/apiv1/commonConfig/update', params)
}

/**
 * 添加模板  /apiv1/commonConfig/update
 * @param {*} params
 */
export const templateAdd = params => {
  return Vue.fetch.post('/apiv1/commonConfig/add', params)
}

/**
 * 获取模板预设列表
 * @param {*} params
 */
export const list = params => {
  return Vue.fetch.post('/apiv1/commonConfig/findList', params)
}

export const add = params => {
  return Vue.fetch.post('/apiv1/zksys/options/add', params)
}

export const remove = params => {
  return Vue.fetch.post('/apiv1/zksys/options/remove', params)
}

export const update = params => {
  return Vue.fetch.post('/apiv1/zksys/options/update', params)
}

export const query = params => {
  return Vue.fetch.post('/apiv1/zksys/options/query', params)
}



// WEBPACK FOOTER //
// ./src/services/sysOptionsApi.js